// extracted by mini-css-extract-plugin
export default {"staffMemberInfoContainer":"styles_staffMemberInfoContainer__uwf4i"};